<template>
  <div class="entInfo-container">
    <div class="entInfo-content max-width">
      <div class="item" v-for="item in listData" :key="item.id">
        <img class="icon" :src="item.icon">
        <div class="value font-size-60">{{tweenData[item.key] | getInt}}{{item.valueSuffix}}</div>
        <div class="title font-size-16">{{item.title}}</div>
      </div>
    </div>
  </div>
</template>
<script>
import Tween from "@tweenjs/tween.js";
import ic_company from "@/assets/honor/ic_company@2x.png";
import ic_honor from "@/assets/honor/ic_honor@2x.png";
import ic_project from "@/assets/honor/ic_project@2x.png";
import ic_good from "@/assets/honor/ic_good@2x.png";


export default {
  Tween: null, // 缓动对象
  flag: null, // 定时器对象
  filters: {
    getInt(num) {
      return Number(num).toFixed(0);
    }
  },
  data() {
    return {
      tweenData: {
        tweenYearNumber: 0,
        tweenHonorNumber: 0,
        tweenserviceNumber: 0,
        tweenevaluateNumber: 0
      },
      listData: [
        {
          id: 1,
          icon: ic_company,
          title: "公司成立",
          valueSuffix: "",
          key: "tweenYearNumber"
        },
        {
          id: 2,
          icon: ic_honor,
          title: "荣誉资质",
          valueSuffix: "",
          key: "tweenHonorNumber"
        },
        {
          id: 3,
          icon: ic_project,
          title: "服务项目",
          valueSuffix: "",
          key: "tweenserviceNumber"
        },
        {
          id: 4,
          icon: ic_good,
          title: "好评率",
          valueSuffix: "%",
          key: "tweenevaluateNumber"
        }
      ]
    };
  },
  props: {
    entInfoData: {
      type: Object,
      default: () => ({
        year: 0,
        honor: 0,
        service: 0,
        evaluate: 0
      })
    }
  },
  watch: {
    entInfoData: {
      deep: true,
      handler(newValue) {
        const { year, honor, service, evaluate } = newValue;
        this.Tween.to({
          tweenYearNumber: year,
          tweenHonorNumber: honor,
          tweenserviceNumber: service,
          tweenevaluateNumber: evaluate
        }).start();
      }
    }
  },
  methods: {
    startAnimate() {
      this.flag = setInterval(() => Tween.update(), 22);
    },
  },
  mounted() {
    this.Tween = new Tween.Tween(this.$data.tweenData);
    this.startAnimate();
  },
  destroyed() {
    this.Tween = null;
    this.flag = null;
    clearInterval(this.flag);
  }
};
</script>
<style lang="scss" scoped>
@import url("~@/assets/css/common.scss");
.entInfo-container {
  width: 100%;
  min-height: 18.75vw;
  background-image: url("~@/assets/honor/bg_qualification@2x.png");
  background-size: 101% 101%;
  background-repeat: no-repeat;
  background-position: center;
  display: flex;
  align-items: center;
  .entInfo-content {
    width: 1366px;
    margin: auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: auto;
    color: #fff;
    padding: 20px;
    .item {
      text-align: center;
      flex-grow: 1;
      width: 25%;
      user-select: none;
      .icon {
        height: 3vw;
        display: block;
        margin: auto;
        margin-bottom: 60px;
      }
      .value {
        font-family: Arial-BoldMT;
        font-weight: bold;
        color: rgba(255, 255, 255, 1);
        margin-bottom: 24px;
      }
      .title {
        font-family: SourceHanSansCN-Regular;
        font-weight: 400;
        color: rgba(255, 255, 255, 1);
      }
    }
  }
}
</style>
